import request from '@/utils/request'

export function getExtraImages (data) {
  return request({
    url: '/api/admin/extra-images',
    method: 'post',
    data: data
  })
}

export function updateExtraImages (data) {
  return request({
    url: '/api/admin/extra-images/update',
    method: 'post',
    data: data
  })
}
